import type { AllRouteEndpoints } from "../routeTypes";
export const companiesCompanyIdDevelopersDeveloperIdUnsuspendCacheKeys: AllRouteEndpoints[] = [
  "/companies/:company_id/developers",
  "/companies/:company_id/developers/table",
];
